/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IdDiamondCard1 = ({ className, color = "black" }) => {
  return (
    <svg
      className={`id-diamond-card-1 ${className}`}
      fill="none"
      height="45"
      viewBox="0 0 45 45"
      width="45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#F2F3F7"
        height="36.7695"
        rx="18.3848"
        transform="rotate(45 22.5 -3.31348)"
        width="36.7695"
        x="22.5"
        y="-3.31348"
      />

      <g className="g" clipPath="url(#clip0_2633_323)">
        <path
          className="path"
          d="M31.5 15.0688H13.5C12.3954 15.0688 11.5 15.9643 11.5 17.0688V29.0688C11.5 30.1734 12.3954 31.0688 13.5 31.0688H31.5C32.6046 31.0688 33.5 30.1734 33.5 29.0688V17.0688C33.5 15.9643 32.6046 15.0688 31.5 15.0688Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />

        <path
          className="path"
          d="M11.5 21.0688H33.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_2633_323">
          <rect
            className="rect"
            fill="white"
            height="24"
            transform="translate(10.5 11.0688)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
